import { render } from "./ProdutoAdicionarVariacao.vue?vue&type=template&id=760ef20e&scoped=true&ts=true"
import script from "./ProdutoAdicionarVariacao.vue?vue&type=script&lang=ts"
export * from "./ProdutoAdicionarVariacao.vue?vue&type=script&lang=ts"

import "./ProdutoAdicionarVariacao.vue?vue&type=style&index=0&id=760ef20e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760ef20e"]])

export default __exports__